'use strict';

const {__} = wp.i18n;

/**
 * Init All Uploads Logic
 */
class TWER_UPLOADS {

  /**
   * Uploads constructor
   *
   * @param props
   */
  constructor(props) {
    // Init JQuery
    this.$ = $ = props;

    const $addAttach = document.querySelectorAll('.js-twer-attach-add');
    const $removeAttach = document.querySelectorAll('.js-twer-attach-remove');


    // Click on Upload attach button in metabox
    $addAttach.forEach((element) => {
      element.addEventListener('click', event => {
        event.preventDefault();
        const $btn = event.target;
        let xmlFrame;
        if (xmlFrame) {
          xmlFrame.open();
          return;
        }
        xmlFrame = wp.media({
          title: __('Select image', 'treweler'),
          button: {
            text: __('Upload image', 'treweler')
          },
          library: {
            type: ['image'],
          },
          multiple: false
        });
        xmlFrame.on('select', () => {
          const xmlFrameFile = xmlFrame.state().get('selection').first();
          const xmlUrl = xmlFrameFile.toJSON().url;
          const xmlId = xmlFrameFile.toJSON().id;
          const $attachWrap = $btn.closest('.js-twer-attach-wrap');
          const $thumbWrap = $attachWrap.getElementsByClassName('js-twer-attach-thumb')[0];

          const $img = document.createElement('img');
          $img.setAttribute('src', xmlUrl);
          $img.setAttribute('alt', xmlFrameFile.changed.title);

          $attachWrap.getElementsByTagName('img')[0]?.remove();
          $thumbWrap.appendChild($img);
          if (!$btn.classList.contains('button')) {
            $btn.style.display = 'none';
          }
          $thumbWrap.nextElementSibling.style.display = 'block';
          $attachWrap.getElementsByTagName('input')[0].value = xmlId;

          $(document).trigger('twer-attach-add', [xmlFrame]);
        });
        xmlFrame.open();
      });

    });

    // Click on Remove attach button in metabox
    $removeAttach.forEach((element) => {
      element.addEventListener('click', event => {
        event.preventDefault();
        const $btn = event.target;
        const $attachWrap = $btn.closest('.js-twer-attach-wrap');
        const $thumbWrap = $attachWrap.getElementsByClassName('js-twer-attach-thumb')[0];
        $attachWrap.getElementsByTagName('img')[0]?.remove();
        $attachWrap.getElementsByTagName('input')[0].value = '';
        $btn.closest('.js-twer-attach-actions').style.display = 'none';
        $thumbWrap.getElementsByClassName('js-twer-attach-add')[0].style.display = 'block';

        $(document).trigger('twer-attach-remove');
      });
    });

    const $addAttachGallery = document.querySelectorAll('.js-twer-attach-gallery-add');

    $('.js-twer-attach-gallery-wrap').each((index, element) => {
      const $sortableList = $(element);
      $sortableList.sortable({
        cursor: 'move',
        placeholder: 'twer-attach-gallery__thumb',
        forcePlaceholderSize: true,
        forceHelperSize: true,
        scroll: true,
        revert: false,
        tolerance: 'pointer',
        items: '> div',
        update: function(event, ui) {
          const $input = $sortableList.find('input');
          const ids = [];
          $sortableList.children('div').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          $input.val(ids.join(','));
        }
      }).disableSelection();
    });

    $(document).on('click', '.js-twer-attach-gallery-remove', function(e) {
      e.preventDefault();
      const $sortableList = $(this).closest('.js-twer-attach-gallery-wrap');
      const $input = $sortableList.find('input');
      const ids = [];
      $(this).closest('.twer-attach-gallery__thumb').remove();
      $sortableList.children('div').each(function(divIndex, div) {
        ids.push($(div).data('id'));
      });
      $input.val(ids.join(','));
    });

    // Click on Upload attach gallery button in metabox
    $addAttachGallery.forEach((element) => {
      element.addEventListener('click', event => {
        event.preventDefault();
        const $btn = event.target;
        let xmlFrame;
        if (xmlFrame) {
          xmlFrame.open();
          return;
        }
        xmlFrame = wp.media({
          title: __('Select images', 'treweler'),
          button: {
            text: __('Upload images', 'treweler')
          },
          library: {
            type: ['image'],
          },
          multiple: 'add'
        });

        xmlFrame.on('open', () => {
          const $attachWrap = $btn.closest('.js-twer-attach-gallery-wrap');
          const attachIds = $attachWrap.getElementsByTagName('input')[0].value;
          let selection = xmlFrame.state().get('selection');

          if (attachIds.length > 0) {
            let ids = attachIds.split(',');

            ids.forEach(function(id) {
              let attachment = wp.media.attachment(id);
              attachment.fetch();
              selection.add(attachment ? [attachment] : []);
            });
          }
        });

        xmlFrame.on('select', () => {

          const selection = xmlFrame.state().get('selection');
          const $attachWrap = $btn.closest('.js-twer-attach-gallery-wrap');
          const attachIds = [];

          const elements = $attachWrap.getElementsByClassName('twer-attach-gallery__thumb');
          while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
          }

          //let index = 0;
          selection.map(function(attachment) {
            attachment = attachment.toJSON();
            let $divThumb = document.createElement('div');
            $divThumb.setAttribute('class', 'twer-attach-gallery__thumb');
            $divThumb.setAttribute('data-id', attachment.id);
            //$divThumb.setAttribute('data-index', index++);

            let $imgThumb = document.createElement('img');
            $imgThumb.setAttribute('src', attachment.url);
            $imgThumb.setAttribute('alt', attachment.title);

            let $close = document.createElement('a');
            $close.setAttribute('href', '#');
            $close.setAttribute('title', __('Remove', 'treweler'));
            $close.setAttribute('class', 'twer-attach-gallery__remove js-twer-attach-gallery-remove');
            $divThumb.appendChild($imgThumb);
            $divThumb.appendChild($close);

            $attachWrap.insertBefore($divThumb, $btn);

            //console.log($attachWrap, $divThumb, $btn);

            attachIds.push(attachment.id);

          });

          $attachWrap.getElementsByTagName('input')[0].value = attachIds.join(',');

        });
        xmlFrame.open();
      });

    });
  }

}

export default TWER_UPLOADS;
